import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";

import { ScreenSizeProvider } from "./Utils/contexts";
import React, { useState, useEffect } from "react";
import Navbar from "./Components/Navbar/Navbar";
import About from "./Components/About/About";
import LeftPanel from "./Components/LeftPanel/LeftPanel";
import Landing from "./Components/Landing/Landing";
import Contact from "./Components/Contact/Contact";
import Projects from "./Components/Projects/Projects";
import Experience from "./Components/Experience/Experience";
import Footer from "./Components/Footer/Footer";


function App() {
  const [size, setSize] = useState(window.innerWidth);
  const [submitState, setSubmitState] = useState(0);
  
  const handleResize = () => {
    setSize(window.innerWidth);
  };

 

  useEffect(() => {
    AOS.init({ duration: 750 });
    window.addEventListener("resize", handleResize);

    // set up a clean up function
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="App">
      <ScreenSizeProvider
        value={{
          size,
          isLaptop: size > 750,
          isMobile: size < 425,
          submitState,
          setSubmitState,
        }}
      >
        <div className="main-div">
          
          <LeftPanel />
          <Navbar />
          <Landing />
          <About />
          <Experience />
          <Projects />
          <Contact />
          <Footer />
        </div>
      </ScreenSizeProvider>
    </div>
  );
}

export default App;
